import React from "react";
import InputLabel from "@mui/material/InputLabel";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

const CustomInfoWithLabel: React.FC<{
  label: string;
  text: string;
  rightIcon?: React.ReactNode;
}> = ({ label, text, rightIcon }) => {
  return (
    <Stack maxWidth="100%" overflow="hidden">
      <InputLabel shrink>{label}</InputLabel>
      <Stack direction="row" width="100%" alignItems="center" justifyContent="space-between">
        <Typography
          sx={(theme) => ({
            wordWrap: "break-word",
            flexGrow: 1,
            maxWidth: `calc(100% - ${rightIcon != null ? theme.spacing(5) : 0})`,
          })}
        >
          {text}
        </Typography>
        {rightIcon != null && <Box sx={{ flexShrink: 0 }}>{rightIcon}</Box>}
      </Stack>
    </Stack>
  );
};

export default CustomInfoWithLabel;
